import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  // hgText: {
  //   fontWeight: 500,
  // },
  centerText: {
    fontWeight: 500,
    paddingBottom: 10,
    textAlign: 'center',
  },
  root: {
    '& .MuiFormControl-marginNormal': {
      marginTop: 0,
      marginBottom: 0,
    },
    "& .MuiAutocomplete-inputRoot[class*='MuiInput-root']": {
      padding: '6px',
    },
  },
    // Filter field font size by screen width
  filterField: {
    fontSize: 14,
   fontWeight: 500,
    [theme.breakpoints.up(1350)]: {
      fontSize: 16,
    },
    [theme.breakpoints.up(1680)]: {
      fontSize: 18,
    },
    [theme.breakpoints.up(1920)]: {
      fontSize: 20,
    },
  },

  // Filter value font size by screen width
  filterFieldValue: {
    fontSize: 14,
    [theme.breakpoints.up(1680)]: {
      fontSize: 16,
    },
    [theme.breakpoints.up(1920)]: {
      fontSize: 18,
    },
  },
}));
